import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import Base from '../Select'

export const GET_MODELS = gql`
  {
    models {
      id
      name
    }
  }
`

const Select = ({...others}) => {
  return (
    <Query query={GET_MODELS} fetchPolicy='cache-and-network'>
      {({data}) =>
        <Base
          placeholder='Select a model...'
          options={!data || !data.models
            ? []
            : data.models.map(m => ({key: m.id, label: m.name, value: m.id}))}
          {...others}
        />
      }
    </Query>
  )
}

export default Select


// WEBPACK FOOTER //
// ./src/components/Models/Select.js